import React from 'react';
import { useInputHelper } from './inputHelper';
import { BaseInputLayoutProps, BaseInputProps } from './types';
import { useNewUiTheme } from '../../newUiTheme';

export interface WysiwygProps extends BaseInputProps {
  hideControls?: boolean;
  disableHotkeys?: boolean;
  maxImageWidth?: number
}

export interface WysiwygLayoutProps extends BaseInputLayoutProps {
  hideControls?: boolean;
  disableHotkeys?: boolean;
  maxImageWidth?: number
}

export function Wysiwyg(props: WysiwygProps) {
  const inputHelper = useInputHelper(props);

  const uiTheme = useNewUiTheme();

  return (
    <uiTheme.inputs.WysiwygLayout
      {...inputHelper.getBaseInputLayoutProps()}
      hideControls={props.hideControls}
      disableHotkeys={props.disableHotkeys}
      maxImageWidth={props.maxImageWidth}
    />
  )
}
